<template>
  <div class="md-layout" id="margins-menu">
    <div v-if="dataLoaded" class="md-layout-item md-size-3 no-padding margins-menu-labels">
      <div v-if="doble" class="margins-menu-cult">{{firstCrop}}</div>
      <div v-if="doble" class="margins-menu-cult">Soja</div>
    </div>
    <div v-if="dataLoaded" class="md-laout-item margin-item-container" :key="componentKey">
      <div class="md-layout margin-item-wrap">
        <margin-item name="Precio (USD/t)"
                     :data="data.precio"
                     class="margin-box"
                     type="precio"
                     @update-value1="updateValue1"
                     @update-value2="updateValue2"/>
        <margin-item name="Rinde (qq/ha)"
                     :data="data.rinde"
                     class="margin-box"
                     type="rinde"
                     @update-value1="updateValue1"
                     @update-value2="updateValue2"/>
        <margin-item name="Cto. de cultivo (USD/ha)"
                     :data="data.ctocul"
                     type="ctocul"
                     class="margin-box"
                     @update-value1="updateValue1"
                     @update-value2="updateValue2"/>
        <margin-item name="Gtos. Com. (%)"
                     :data="data.gtocom"
                     type="gtocom"
                     class="margin-box"
                     @update-value1="updateValue1"
                     @update-value2="updateValue2"/>
        <margin-item name="Alquiler (qq sj/ha)"
                     :data="data.alquiler"
                     class="margin-box"
                     type="alquiler"
                     @update-value1="updateValue1"
                     @update-value2="updateValue2"/>
      </div>
    </div>
    <div  class="md-layout-item md-size-100 pull-left">
      <md-button class="md-default md-warning md-sm reset-button" @click="reset">Restablecer valores originales</md-button>
    </div>
    <div  class="md-layout-item md-size-100">
      <table class="select-table">
        <td class="select-label">Seleccione <span class="hide-mobile">la columna a modificar</span><md-icon>arrow_forward</md-icon></td>
          <td><input v-if="visibleColumn(1)" @click="updateValues(1)" type="radio" value=1 name="radio" checked></td>
          <td><input v-if="visibleColumn(2)" @click="updateValues(2)" type="radio" value=2 name="radio"></td>
          <td class="hide-960"><input v-if="visibleColumn(3)" @click="updateValues(3)" type="radio" value=3 name="radio"></td>
          <td class="hide-960"><input v-if="visibleColumn(4)" @click="updateValues(4)" type="radio" value=4 name="radio"></td>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MarginItem from '@/components/Comparative/MarginItem'
export default {
  name: 'margins-menu',
  components: {MarginItem},
  props: ['tableData', 'regionSelected', 'cropSelected'],
  data () {
    return {
      dataRow: null,
      doble: false,
      firstCrop: "Trigo",
      selectedColumn: 1,
      componentKey: 1,
      dataLoaded: false,
      dataColumn1 : null,
      dataColumn2 : null,
      dataColumn3 : null,
      dataColumn4 : null,
      data: {},
    }
  },
  watch: {
    'regionSelected.one': function (){
      this.dataColumn1 = null;
      if (this.selectedColumn == 1) {
        this.updateValues(1);
        this.forceRerender();
      }
    },
    'regionSelected.two': function (){
      this.dataColumn2 = null;
      if (this.selectedColumn == 2) {
        this.updateValues(2);
        this.forceRerender();
      }
    },
    'regionSelected.three': function (){
      this.dataColumn3 = null;
      if (this.selectedColumn == 3) {
        this.updateValues(3);
        this.forceRerender();
      }
    },
    'regionSelected.four': function (){
      this.dataColumn4 = null;
      if (this.selectedColumn == 4) {
        this.updateValues(4);
        this.forceRerender();
      }
    },
    'cropSelected.one': function (){
      this.dataColumn1 = null;
      if (this.selectedColumn == 1) {
        this.updateValues(1);
        this.forceRerender();
      }
    },
    'cropSelected.two': function (){
      this.dataColumn2 = null;
      if (this.selectedColumn == 2) {
        this.updateValues(2);
        this.forceRerender();
      }
    },
    'cropSelected.three': function (){
      this.dataColumn3 = null;
      if (this.selectedColumn == 3) {
        this.updateValues(3);
        this.forceRerender();
      }
    },
    'cropSelected.four': function (){
      this.dataColumn4 = null;
      if (this.selectedColumn == 4) {
        this.updateValues(4);
        this.forceRerender();
      }
    },

  },
  created() {
    //this.$nextTick(this.updateValues(1));
    let vm = this;
    setTimeout(function(){ vm.updateValues(1) }, 500);
  },
  methods: {
    ...mapActions(['getDataRow']),

    reset() {
      switch(this.selectedColumn) {
      case 1: this.dataColumn1 = null; break;
      case 2: this.dataColumn2 = null; break;
      case 3: this.dataColumn3 = null; break;
      case 4: this.dataColumn4 = null; break;
      }
      this.updateValues(this.selectedColumn);
      this.forceRerender();
      this.$emit('reset-column', this.selectedColumn);
    },
    visibleColumn(number) {
      switch (number) {
      case 1: return true;
      case 2: return (this.tableData[0] && this.tableData[0].column2 !== '') ? true : false;
      case 3: return (this.tableData[0] && this.tableData[0].column3 !== '') ? true : false;
      case 4: return (this.tableData[0] && this.tableData[0].column4 !== '') ? true : false;
      }
    },
    updateValue1(value, type){
      let dataColumn = this.getDataColumn();
      switch(type){
      case 'precio': dataColumn.precio.value1 = value; dataColumn.gtocom.info.value1 = parseInt((dataColumn.gtocom.value1 * dataColumn.precio.value1) / 100); break;
      case 'rinde': dataColumn.rinde.value1 = value; break;
      case 'ctocul': dataColumn.ctocul.value1 = value; break;
      case 'gtocom': dataColumn.gtocom.value1 = value; dataColumn.gtocom.info.value1 = parseInt((dataColumn.gtocom.value1 * dataColumn.precio.value1) / 100); break;
      case 'alquiler': dataColumn.alquiler.value1 = value; dataColumn.alquiler.info.value1 = parseInt((dataColumn.alquiler.value1 * this.dataRow['prec_de_soja']) / 10); break;

      }
      this.$emit('margins-changed', this.selectedColumn, this.dataColumn1, this.dataColumn2, this.dataColumn3, this.dataColumn4);
    },
    updateValue2(value, type){
      let dataColumn = this.getDataColumn();
      switch(type){
      case 'precio': dataColumn.precio.value2 = value; dataColumn.gtocom.info.value2 = parseInt((dataColumn.gtocom.value2 * dataColumn.precio.value2) / 100); break;
      case 'rinde': dataColumn.rinde.value2 = value; break;
      case 'ctocul': dataColumn.ctocul.value2 = value; break;
      case 'gtocom': dataColumn.gtocom.value2 = value; dataColumn.gtocom.info.value2 = parseInt((dataColumn.gtocom.value2 * dataColumn.precio.value2) / 100); break;
      case 'alquiler': dataColumn.alquiler.value2 = value; dataColumn.alquiler.info.value2 = parseInt((dataColumn.alquiler.value2 * this.dataRow['prec_de_soja']) / 10); break;
      }
      this.$emit('margins-changed', this.selectedColumn, this.dataColumn1, this.dataColumn2, this.dataColumn3, this.dataColumn4);
    },
    doubleCrop(data) {
      return (data['cultivo'].indexOf('-') == -1) ? false : true;
    },
    getFirstCrop(data) {
      return (data['cultivo'].split('-')[0]);
    },
    setInitData(data, dataColumn) {
      let double = this.doubleCrop(data);
      this.doble = double;
      this.firstCrop = this.getFirstCrop(data);
      dataColumn = {
        precio: {},
        rinde: {},
        gtocom: {},
        ctocul: {},
        alquiler: {}
      };
      dataColumn.precio.doble = double;
      dataColumn.rinde.doble = double;
      dataColumn.gtocom.doble = double;
      dataColumn.ctocul.doble = double;
      dataColumn.alquiler.doble = double;

      return dataColumn;
    },
    setPrimaryValues(data, dataColumn) {
      dataColumn.precio.value1 = parseInt(data['precio_c1_e']);
      dataColumn.rinde.value1 = parseInt(data['rinde_c1_e']);
      dataColumn.gtocom.value1 = parseFloat(data['gtos_comerciales_c1_e']).toFixed(1);
      dataColumn.ctocul.value1 = parseInt(data['costo_c1_s_alq_e']);
      dataColumn.alquiler.value1 = parseInt(data['alquiler_c1_e']);

      return dataColumn;
    },
    setInfo(data, dataColumn) {
      dataColumn.precio.info = false;
      dataColumn.rinde.info = false;
      dataColumn.gtocom.info = {
        name: 'Gtos. Com. (USD/t)',
        value1: parseInt((dataColumn.gtocom.value1 * dataColumn.precio.value1) / 100),
        value2: parseInt((dataColumn.gtocom.value2 * dataColumn.precio.value2) / 100)
      };
      dataColumn.ctocul.info = false;
      dataColumn.alquiler.info = {
        name: 'Alquiler (USD/ha)',
        value1: parseInt((dataColumn.alquiler.value1 * data['prec_de_soja']) / 10),
        value2: parseInt((dataColumn.alquiler.value2 * data['prec_de_soja']) / 10)
      };

      return dataColumn;
    },
    setSecondaryValues(data, dataColumn) {
      dataColumn.precio.value2 = parseInt(data['precio_c2_e']);
      dataColumn.rinde.value2 = parseInt(data['rinde_c2_e']);
      dataColumn.gtocom.value2 = parseFloat(data['gtos_comerciales_c2_e']).toFixed(1);
      dataColumn.ctocul.value2 = parseInt(data['costo_c2_s_alq_e']);
      dataColumn.alquiler.value2 = parseInt(data['alquiler_c2_e']);

      return dataColumn;
    },
    getDataColumn() {
      switch(this.selectedColumn) {
      case 1: return this.dataColumn1; break;
      case 2: return this.dataColumn2; break;
      case 3: return this.dataColumn3; break;
      case 4: return this.dataColumn4; break;
      }
    },
    setDataColumn(dataColumn) {
      switch(this.selectedColumn) {
      case 1: return this.dataColumn1 = dataColumn; break;
      case 2: return this.dataColumn2 = dataColumn; break;
      case 3: return this.dataColumn3 = dataColumn; break;
      case 4: return this.dataColumn4 = dataColumn; break;
      }
    },

    updateValues(number) {
      this.selectedColumn = number;
      let payload = this.getCropAndRegion();
      this.getDataRow(payload).then((data) => {
        this.dataRow = data;
        let dataColumn = this.getDataColumn();

        if (!dataColumn) {
          dataColumn = this.setInitData(data, dataColumn);

          // SETEO LOS VALORES DE ARRIBA DE CADA UNO
          dataColumn = this.setPrimaryValues(data, dataColumn);

          // SETEO LOS VALORES DE ABAJO DE CADA UNO
          if (dataColumn.precio.doble)
            dataColumn = this.setSecondaryValues(data, dataColumn);

          // SETEO EL INFO
          dataColumn = this.setInfo(data, dataColumn);

        }
        this.doble = this.doubleCrop(data);
        this.setDataColumn(dataColumn);
        this.data = dataColumn;
        this.dataLoaded = true;
        this.forceRerender();

      });
    },

    forceRerender() {
      this.componentKey += 1;
    },
    getCropAndRegion() {
      if (this.selectedColumn == 1)
        return {
          regionSelected: this.regionSelected.one,
          cropSelected: this.cropSelected.one
        }
      if (this.selectedColumn == 2)
        return {
          regionSelected: this.regionSelected.two,
          cropSelected: this.cropSelected.two
        }
      if (this.selectedColumn == 3)
        return {
          regionSelected: this.regionSelected.three,
          cropSelected: this.cropSelected.three
        }
      if (this.selectedColumn == 4)
        return {
          regionSelected: this.regionSelected.four,
          cropSelected: this.cropSelected.four
        }
    }
  }

}
</script>
<style>
.select-table{
  background-color: #ddd;
}
#margins-menu {
  margin-top:60px;
}
.margin-item-container{
  overflow-x: auto;
}
.margin-item-wrap{
  width: 1150px;
  flex-wrap: nowrap;
}
.margin-box{
  border: 1px solid #ddd;
  padding: 3px;
}
.pull-right{
  text-align: right
}
.margins-menu-cult{
  font-size: 15px;
  text-align: center;
  margin-top:10px;
  color: #4caf50;
}
.select-label{
  font-size:12px;
}
@media only screen and (max-width: 960px) {
  .hide-960{
    display: none
  }
  .margins-menu-labels {
    display: none;
  }
}
@media only screen and (max-width: 600px) {
  .hide-mobile{
    display: none
  }
  .reset-button{
    width: 100%;
  }
  .select-label{
    width: 27% !important
  }
  #margins-menu{
    margin-top: 40px;
    padding-top: 90px;
  }
}
</style>
